import url from './url';

async function listBanners() {

    let data = await fetch(`${url}/banner/list`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { listBanners }